import { render, staticRenderFns } from "./platformEvaluation.vue?vue&type=template&id=19fd6cdc&scoped=true"
import script from "./platformEvaluation.vue?vue&type=script&lang=js"
export * from "./platformEvaluation.vue?vue&type=script&lang=js"
import style0 from "./platformEvaluation.vue?vue&type=style&index=0&id=19fd6cdc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fd6cdc",
  null
  
)

export default component.exports